(ns teamoesterreich.admin-mode.lebensretter.detail.clearance-part

  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.info :refer [info]]
            ["date-fns" :refer [differenceInYears differenceInMonths]]

            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.lebensretter.detail.document-extend-part :as document-extend-part]
            [teamoesterreich.admin-mode.lebensretter.detail.document-identification-part :as document-identification-part]
            [teamoesterreich.admin-mode.lebensretter.detail.document-selfExplain-part :as document-selfExplain-part]
            [teamoesterreich.admin-mode.lebensretter.detail.document-training-part :as document-training-part]
            [teamoesterreich.admin-mode.lebensretter.detail.jku-linz-part :as jku-linz-part]
            [teamoesterreich.admin-mode.lebensretter.detail.lna-part :as lna-part]
            [teamoesterreich.admin-mode.lebensretter.detail.region-part :as region-part]
            [teamoesterreich.admin-mode.lebensretter.detail.zip-sms-part :as zip-sms-part]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.setup :as setup]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]

            ))



(defn parse-date [date]
  ;(log/debug "################### " (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8) ))
  (js/Date.parse (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8))))

(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    ""
    ))
(defn date-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" "120000.000Z"))




(defn clearance [!edit !actual-user wop-clearance]
  (let [regionLr_ (select-keys (reduce (fn [c e] (assoc c e true)) {} (clojure.string/split (:lrClearance-lrRegionHack wop-clearance) #"\|")) (txt/txt :fake :lr-regions))
        regionFr_ (select-keys (reduce (fn [c e] (assoc c e true)) {} (clojure.string/split (:lrClearance-frRegionHack wop-clearance) #"\|")) (txt/txt :fake :fr-regions))
        storedAlways (or (:lrClearance-postalCodesAlways wop-clearance) "")
        storedNever (or (:lrClearance-postalCodesNever wop-clearance) "")
        smsFallbackActive (or (:lrClearance-smsFallback wop-clearance) false)
        lnaActive (or (:lrClearance-lna wop-clearance) false)
        jkuLinzActive (or (:lrClearance-jkuLinz wop-clearance) false)

        !st (r/atom {:changed?                        false
                     :valid-clearance-lr-region       regionLr_
                     :valid-clearance-fr-region       regionFr_
                     :lrClearance-end                 (or (:lrClearance-end wop-clearance) "20260305T120000.000Z")
                     :lrClearance-type                (or (:lrClearance-type wop-clearance) "EH")
                     :lrClearance-qualification-until (or (:lrClearance-qualification-until wop-clearance) "20260305T120000.000Z")
                     :lrClearance-qualification-valid (or (:lrClearance-qualification-valid wop-clearance) false)
                     :lrClearance-postalCodesAlways   (or (:lrClearance-postalCodesAlways wop-clearance) "")
                     :lrClearance-postalCodesNever    (or (:lrClearance-postalCodesNever wop-clearance) "")
                     :lrClearance-smsFallback         (or (:lrClearance-smsFallback wop-clearance) false)
                     :lrClearance-lna                 (or (:lrClearance-lna wop-clearance) false)
                     :lrClearance-jkuLinz             (or (:lrClearance-jkuLinz wop-clearance) false)
                     })
        !regionLr (r/cursor !st [:valid-clearance-lr-region])
        !regionFr (r/cursor !st [:valid-clearance-fr-region])
        !show-confirm-popup (r/cursor !st [:show-confirm-popup])
        !show-confirm-remove-popup (r/cursor !st [:show-confirm-remove-popup])
        !invalidate-LrClearance-end (r/cursor !st [:invalidate-lrClearance-end])
        !postalCodesAlways (r/cursor !st [:lrClearance-postalCodesAlways])
        !postalCodesNever (r/cursor !st [:lrClearance-postalCodesNever])
        !smsFallback (r/cursor !st [:lrClearance-smsFallback])
        !lna (r/cursor !st [:lrClearance-lna])
        !jkuLinz (r/cursor !st [:lrClearance-jkuLinz])
        ]
    (fn []
      (let [
            proposed-identity-document (:lrClearance-identityDocument wop-clearance)
            proposed-identity-document (or proposed-identity-document (first (filter (fn [{active :userDocument-active isIdentity :userDocument-isIdentity}] (and active isIdentity)) (:user-userDocument @!actual-user))))
            proposed-identity-document (or proposed-identity-document (first (filter (fn [{active :userDocument-active type :userDocument-type}] (and active (= type "identification"))) (:user-userDocument @!actual-user))))

            proposed-selfDeclaration-document (:lrClearance-selfExplainDocument wop-clearance)
            proposed-selfDeclaration-document (or proposed-selfDeclaration-document (first (filter (fn [{active :userDocument-active isSelfExplain :userDocument-isSelfExplain}] (and active isSelfExplain)) (:user-userDocument @!actual-user))))
            proposed-selfDeclaration-document (or proposed-selfDeclaration-document (first (filter (fn [{active :userDocument-active type :userDocument-type}] (and active (= type "selfDeclaration"))) (:user-userDocument @!actual-user))))

            proposed-training-document (:lrClearance-trainingDocument wop-clearance)
            proposed-training-document (or proposed-training-document (first (filter (fn [{active :userDocument-active type :userDocument-type}] (and active (= type "lebensretter-qualification"))) (:user-userDocument @!actual-user))))

            proposed-extend-document (:lrClearance-extendDocument wop-clearance)
            proposed-extend-document (or proposed-extend-document (first (filter (fn [{active   :userDocument-active type :userDocument-type
                                                                                       uploaded :userDocument-since isTraining :userDocument-isTraining validTo :userDocument-validTo}]

                                                                                   (and active
                                                                                        (= type "lebensretter-qualification")
                                                                                        (or (not (:userDocument-isTraining proposed-training-document))
                                                                                            (> (h-date/parse-rest-time uploaded) (h-date/parse-rest-time (:userDocument-since proposed-training-document))))))

                                                                                 (:user-userDocument @!actual-user))))

            p-identity-ok? (:userDocument-isIdentity proposed-identity-document)
            p-hdyValid-ok? (:user-hdyValid @!actual-user)
            p-emailValid-ok? (:user-emailValid @!actual-user)
            p-selfDeclaration-ok? (:userDocument-isSelfExplain proposed-selfDeclaration-document)

            p-zip-ok? (not= "" (str (:user-zip @!actual-user)))
            p-over-18? (true? (when-let [birthday-str (not-empty (:user-birthday @!actual-user))]
                                (try
                                  (>= (differenceInYears (js/Date.) (h-date/parse-rest-time birthday-str)) 18)
                                  (catch :default e
                                    false))))


            identity-ok? (and p-identity-ok? (:userDocument-isIdentity (:lrClearance-identityDocument wop-clearance)))
            selfDeclaration-ok? (and p-selfDeclaration-ok? (:userDocument-isSelfExplain (:lrClearance-selfExplainDocument wop-clearance)))
            qualification-doc-ok? (and p-identity-ok? (:userDocument-isTraining (:lrClearance-trainingDocument wop-clearance)))


            region-ok? (not-empty @!regionLr)
            date-to-ok? (< (.getTime (new js/Date)) (parse-date (:lrClearance-end @!st)))
            qualification-until-ok? (and (:lrClearance-qualification-until @!st) (< (.getTime (new js/Date)) (parse-date (:lrClearance-qualification-until @!st))))

            clearance-ok? (and
                            identity-ok? selfDeclaration-ok? date-to-ok? region-ok? date-to-ok?)

            clearance-valid (:lrClearance-valid wop-clearance)
            is-cleared? (d-lrClearance/is-cleared wop-clearance)
            is-quali? (d-lrClearance/is-quali wop-clearance)
            qualified? (d-lrClearance/qualified? wop-clearance)

            save-fn (fn [done-fn]
                      (when (and (:userDocument-uuid proposed-training-document)
                                 (:lrClearance-qualification-until @!st)
                                 (not= (:userDocument-uuid proposed-training-document) (:lrClearance-qualification-until @!st)))
                        (d-user/>user-edit-document-field (:userDocument-uuid proposed-training-document)
                                                          {:userDocument-validTo (:lrClearance-qualification-until @!st)}
                                                          (fn [])))
                      (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                              (merge {:lrClearance-type                (or (:lrClearance-type @!st) "EH")
                                                                      :lrClearance-end                 (:lrClearance-end @!st)
                                                                      :lrClearance-qualification-until (:lrClearance-qualification-until @!st)
                                                                      :lrClearance-qualification-valid (:lrClearance-qualification-valid @!st)
                                                                      :lrClearance-lrRegionHack        (reduce (fn [c [k v]] (if v (str c "|" k) c)) "" @!regionLr)
                                                                      :lrClearance-frRegionHack        (reduce (fn [c [k v]] (if v (str c "|" k) c)) "" @!regionFr)
                                                                      :lrClearance-postalCodesAlways   (zip-sms-part/make-valid-zip-list @!postalCodesAlways)
                                                                      :lrClearance-postalCodesNever    (zip-sms-part/make-valid-zip-list @!postalCodesNever)
                                                                      :lrClearance-smsFallback         @!smsFallback
                                                                      :lrClearance-lna                 @!lna
                                                                      :lrClearance-jkuLinz             @!jkuLinz
                                                                      }
                                                                     (when-let [v (:lrClearance-qualification-until @!st)] [:lrClearance-qualification-until v])
                                                                     (when-let [doc-uuid (:userDocument-uuid proposed-identity-document)] [:_identityDocument-uuid doc-uuid])
                                                                     (when-let [doc-uuid (:userDocument-uuid proposed-selfDeclaration-document)] [:_selfDeclarationDocument-uuid doc-uuid])
                                                                     (when-let [doc-uuid (:userDocument-uuid proposed-training-document)] [:_trainingDocument-uuid doc-uuid])
                                                                     )
                                                              #(done-fn)
                                                              ))
            ]
        [mui/card {:style {:textAlign "left" :marginTop "5px"}}

         [mui/collapse {:in true}
          [are-you-sure-modal/are-you-sure-modal !show-confirm-remove-popup "Willst du diese Lebensretter Freigabe wirklich aufheben?" "Jetzt aufheben"
           #(d-lrClearance/>end-clearance (:lrClearance-uuid wop-clearance)
                                          (fn [] (d-user/actual-user-invalidate !actual-user)))]

          [are-you-sure-modal/are-you-sure-modal !show-confirm-popup "Willst du diese Lebensretter Freigabe wirklich freigeben? (Der Nutzer bekommt eine Pushnachricht)" "Jetzt freigeben"
           #(d-lrClearance/>validate-clearance (:lrClearance-uuid wop-clearance)
                                               {:lrClearance-valid true}
                                               (fn [] (d-user/actual-user-invalidate !actual-user)))]



          [mui/card-content

           [mui/grid
            {:container  true
             :direction  "row"
             :alignItems "flex-start"
             :spacing    5
             }
            ;[:p (str (clojure.string/split (:lrClearance-lrRegionHack wop-clearance) #"\|") " -- " regionLr_) [:br] (str (txt/txt :fake :lr-regions))]

            [document-identification-part/identification-block !actual-user proposed-identity-document wop-clearance]

            [document-selfExplain-part/selfExplain-block !actual-user proposed-selfDeclaration-document wop-clearance]




            [mui/grid {:container false :item true
                       :xs        12
                       :style     {}} ""]

            [mui/grid {:container false :item true
                       :lg        3
                       :xs        6
                       :style     {}}
             [mui/text-field {
                              :key             (str "invalidate-LrClearance-end" @!invalidate-LrClearance-end)
                              :style           {:background-color (if (not= (:lrClearance-end @!st) (:lrClearance-end wop-clearance)) "#ffd6d2" "#ffffff")}
                              :fullWidth       true
                              :InputLabelProps {:disableAnimation true :shrink true}
                              :type            "date"
                              :autoOk          true
                              :onChange        (fn [e] (swap! !st assoc :lrClearance-end (date-conv-back (h/event-value e))))
                              :label           (str "Gültig bis ")
                              :defaultValue    (date-conv (:lrClearance-end @!st))
                              }]]
            [mui/grid
             {:container false :item true
              :xs        3
              }
             (when (and (not (:lrClearance-valid wop-clearance))
                        (:userDocument-validTo proposed-selfDeclaration-document)
                        (not= (:userDocument-validTo proposed-selfDeclaration-document) (or (:lrClearance-end @!st) (:lrClearance-end wop-clearance))))
               [mui/button
                {:variant   "contained"
                 :color     "secondary"
                 :onClick   (fn [_]
                              (swap! !st assoc
                                     :lrClearance-end (:userDocument-validTo proposed-selfDeclaration-document)
                                     :invalidate-lrClearance-end (rand-int 100)))
                 :startIcon (r/as-element [keyboard-arrow-left])
                 } "von Selbsterklärung übernehmen"])

             ]

            [mui/grid
             {:container false :item true
              :xs        3
              }
             [mui/form-group
              [mui/form-control-label
               {:style     {:background-color (if is-cleared? "#e4f7e4" "#ffd6d2") :padding "18px 25px 18px 30px" :borderRadius "18px" :border (if is-cleared? "2px solid darkgreen" "2px solid darkred")}
                :label     "Freigegeben"
                :disabled  (not
                             (or is-cleared?
                                 (and p-identity-ok?
                                      p-selfDeclaration-ok?
                                      region-ok?
                                      date-to-ok?
                                      p-hdyValid-ok?
                                      p-emailValid-ok?
                                      p-zip-ok?
                                      p-over-18?
                                      )))
                :fullWidth true
                :control   (r/as-element
                             [mui/switch {:checked  is-cleared?
                                          :onChange (fn [_ v]
                                                      (if v
                                                        (if (or (not= (:lrClearance-type @!st) (:lrClearance-type wop-clearance))
                                                                (not= (:lrClearance-end @!st) (:lrClearance-end wop-clearance))
                                                                (not= (:lrClearance-qualification-until @!st) (:lrClearance-qualification-until wop-clearance))
                                                                (not= (:lrClearance-qualification-valid @!st) (:lrClearance-qualification-valid wop-clearance))
                                                                (not= @!regionLr regionLr_)
                                                                (not= @!regionFr regionFr_)
                                                                )
                                                          (save-fn #(reset! !show-confirm-popup true))
                                                          (reset! !show-confirm-popup true))
                                                        (reset! !show-confirm-remove-popup true)))
                                          }])}
               ]]]

            [mui/grid
             {:container false :item true
              :xs        3}
             (when-not p-identity-ok? [mui/chip {:color "primary" :label "Identität nicht bestätigt" :style {:marginRight "3px"}}])
             (when-not p-zip-ok? [mui/chip {:color "primary" :label "Adresse fehlt" :style {:marginRight "3px"}}])
             (when-not p-over-18? [mui/chip {:color "primary" :label "Alter < 18 Jahre" :style {:marginRight "3px"}}])
             (when-not p-selfDeclaration-ok? [mui/chip {:color "primary" :label "Selbsterklärung nicht bestätigt" :style {:marginRight "3px"}}])
             (when-not region-ok? [mui/chip {:color "primary" :label "Regionen nicht gewählt" :style {:marginRight "3px"}}])
             (when-not date-to-ok? [mui/chip {:color "primary" :label "`Gültig bis ist ungültig" :style {:marginRight "3px"}}])
             (when-not p-hdyValid-ok? [mui/chip {:color "primary" :label "Mobilnummer nicht validiert" :style {:marginRight "3px"}}])
             (when-not p-emailValid-ok? [mui/chip {:color "primary" :label "Email nicht validiert" :style {:marginRight "3px"}}])

             ]



            [mui/grid {:container false :item true
                       :xs        12
                       :lg        6
                       :style     {}}
             [region-part/region-form-lr !regionLr regionLr_]
             ]
            [mui/grid
             {:container false :item true
              :xs        12
              }


             (when (or (not= (:lrClearance-end @!st) (:lrClearance-end wop-clearance))
                       (not= @!regionLr regionLr_)
                       (not= @!regionFr regionFr_)
                       (not= storedAlways @!postalCodesAlways)
                       (not= storedNever @!postalCodesNever)
                       (not= smsFallbackActive @!smsFallback)
                       )
               [mui/button {:variant   "contained"
                            :color     "primary"
                            :style     {:marginLeft "20px"}
                            :startIcon (r/as-element [save])
                            :onClick   (fn [] (save-fn (fn [] (d-user/actual-user-invalidate !actual-user))))

                            }
                "Änderung Speichern"])]


            (when (not (empty? (txt/txt :fake :fr-regions)))
              [mui/grid {:container false :item true
                         :xs        12
                         :lg        6
                         :style     {}}
               (if (d-rights/allow-admin-for d-rights/FIRST_RESPONDER (:user-orgId @!actual-user))
                 [:div
                  (when-not (empty? regionFr_) [mui/chip {:color "primary" :label "Achtung Firstresponder!"}])
                  [region-part/region-form-fr !regionFr regionFr_]
                  (when (and (= (:client setup/config) "toe") (d-rights/allow-admin-for d-rights/FIRST_RESPONDER_POSTAL (:user-orgId @!actual-user)))
                    [zip-sms-part/form !postalCodesAlways !postalCodesNever !smsFallback storedAlways storedNever smsFallbackActive])
                  (when (and (= (:client setup/config) "toe") (d-rights/allow-admin-for d-rights/LEBENSRETTER_LNA (:user-orgId @!actual-user)))
                    [lna-part/form !lna lnaActive])
                  (when (and (= (:client setup/config) "toe") (d-rights/allow-admin-for d-rights/LEBENSRETTER_JKU (:user-orgId @!actual-user)))
                    [jku-linz-part/form !jkuLinz jkuLinzActive])]

                 [:div [:h4 "First Responder Regionen: " (when-not (empty? regionFr_) [mui/chip {:color "primary" :label "Achtung Firstresponder!"}])]
                  [region-part/fr-region-view wop-clearance]]
                 )
               ])

            [mui/grid {:container false :item true
                       :xs        12} ""]

            (when qualified?
              [document-training-part/training-block !actual-user (:lrClearance-trainingDocument wop-clearance) wop-clearance])

            (when (and qualified?
                       (:lrClearance-qualification-until wop-clearance)
                       (> (differenceInMonths (js/Date.) (h-date/parse-rest-time (:lrClearance-qualification-until wop-clearance))) -6))
              [document-extend-part/training-block !actual-user (:lrClearance-extendDocument wop-clearance) wop-clearance]
              )

            [mui/grid {:container false :item true
                       :xs        12} ""]

            (when (d-lrClearance/qualified-activated?)
              [mui/grid {:container false
                         :item      true
                         :lg        3
                         :xs        6
                         :style     {}}
               [mui/form-label (str "Qualifiziert als ")
                [mui/select
                 {
                  :style      {:background-color (if (not= (:lrClearance-type @!st) (:lrClearance-type wop-clearance)) "#ffd6d2" "#ffffff")}
                  :InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [info]])}
                  :fullWidth  true
                  :onChange   (fn [e v] (log/debug "type change " (h/event-value e)) (swap! !st assoc :lrClearance-type (h/event-value e)))
                  :value      (:lrClearance-type @!st)
                  }

                 (for [[k n] (sort-by second (txt/txt :fake :lr-types))]
                   ^{:key (str "type-" k)}
                   [mui/menu-item {:value k} n])
                 ]]])
            (when (d-lrClearance/qualified-activated?)
              [mui/grid {:container false :item true
                         :lg        3
                         :xs        6
                         :style     {}}
               [mui/text-field {
                                :key             (str "invalidate-qualification-until" @!invalidate-LrClearance-end)
                                :style           {:background-color (if (not= (:lrClearance-qualification-until @!st) (:lrClearance-qualification-until wop-clearance)) "#ffd6d2" "#ffffff")}
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :fullWidth       true
                                :type            "date"
                                :autoOk          true
                                :onChange        (fn [e] (swap! !st assoc :lrClearance-qualification-until (date-conv-back (h/event-value e))))
                                :label           (str "Gültig bis ")
                                :defaultValue    (date-conv (:lrClearance-qualification-until @!st))
                                }]])
            (when (d-lrClearance/qualified-activated?)
              [mui/grid
               {:container false :item true
                :xs        3
                }
               (println "proposed-training-document " proposed-training-document " -> " (or (:lrClearance-qualification-until @!st) (:lrClearance-qualification-until wop-clearance)))
               (when (and (:userDocument-validTo proposed-training-document)
                          (not= (:userDocument-validTo proposed-training-document) (or (:lrClearance-qualification-until @!st) (:lrClearance-qualification-until wop-clearance))))
                 [mui/button
                  {:variant   "contained"
                   :color     "secondary"
                   :onClick   (fn [_]
                                (swap! !st assoc
                                       :lrClearance-qualification-until (:userDocument-validTo proposed-training-document)
                                       :invalidate-lrClearance-end (rand-int 100)))
                   :startIcon (r/as-element [keyboard-arrow-left])
                   } "von Qualifikation übernehmen "])

               [mui/form-group
                {:style {:background-color (if is-quali? "#e4f7e4" "#736e6e")
                         :padding          "18px 25px 18px 30px" :borderRadius "18px" :border (if is-quali? "2px solid darkgreen" "2px solid #333131")}}
                [mui/form-control-label
                 {:style     {:background-color (if (not= (:lrClearance-qualification-valid @!st) (:lrClearance-qualification-valid wop-clearance)) "#ffd6d2" "#ffffff")}
                  :label     "Qualifikation freigegeben"
                  :disabled  (not (or (:lrClearance-qualification-valid @!st)
                                      (and
                                        qualification-until-ok?
                                        ;is-cleared?
                                        (or qualification-doc-ok? (not= "" (:lrClearance-qualification-message wop-clearance)))
                                        )))
                  :fullWidth true
                  :control   (r/as-element
                               [mui/switch {:checked  (:lrClearance-qualification-valid @!st)
                                            :onChange (fn [_ v]
                                                        (swap! !st assoc
                                                               :lrClearance-qualification-valid v))}])}
                 ]]

               ])


            (when (d-lrClearance/qualified-activated?)
              [mui/grid
               {:container false :item true
                :xs        3}
               (when-not qualification-until-ok? [mui/chip {:color "primary" :label "Datum fehlt oder ungültig" :style {:margin "3px"}}])
               (when-not (or qualification-doc-ok? (not= "" (:lrClearance-qualification-message wop-clearance)))
                 [mui/chip {:color "primary" :label "Qualifikation Dokument oder Begründung fehlt" :style {:marginRight "5px"}}])
               ])
            [mui/grid {:container false :item true
                       :xs        12} ""]

            [mui/grid
             {:container false :item true
              :xs        5
              }
             (when @!edit
               [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                            :onClick   #(reset! !edit nil)
                            }
                "Schließen"
                ])]

            [mui/grid
             {:container false :item true
              :xs        3
              }


             (when (or
                     (d-lrClearance/qualified-activated?)
                     (not= (:lrClearance-type @!st) (:lrClearance-type wop-clearance))
                     (not= (:lrClearance-end @!st) (:lrClearance-end wop-clearance))
                     (not= (:lrClearance-qualification-until @!st) (:lrClearance-qualification-until wop-clearance))
                     (not= (:lrClearance-qualification-valid @!st) (:lrClearance-qualification-valid wop-clearance))
                     (not= @!regionLr regionLr_)
                     (not= @!regionFr regionFr_)
                     )
               [mui/button {:variant   "contained"
                            :color     "primary"
                            :style     {:marginLeft "20px"}
                            :startIcon (r/as-element [save])
                            :onClick   (fn [] (save-fn (fn [] (d-user/actual-user-invalidate !actual-user))))

                            }
                "Änderung Speichern"])]

            ]]
          ]
         ]))))







